<template>
  <div class="lc-text-msg__wrapper">
    <div
      class="lc-text-msg"
      :class="[side ? 'lc-text-msg-side' : '', 
      notSend ? 'lc-text-msg-not-send' : '']"
    >
      <div>{{ text || $t('view.livechat.templateMessageByBot') }}</div>
    </div>
    <fai v-if="notSend" class="lc-text-retry" icon="redo-alt" @click="retryMsg"></fai>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    side: Boolean,
    notSend: Boolean
  },

  methods: {
    retryMsg() {
      this.$emit('clickedRetry')
    }
  }
}
</script>

<style lang="scss">
.lc-text-msg {
  background: white;
  @include boxShadow(-0px, 2px, 14px, -10px, rgba(0, 0, 0, 0.3));
  border-radius: 20px 20px 20px 0px;
  padding: 10px;
  max-width: 500px;
  overflow-wrap: break-word;
  white-space: pre-wrap;

  &__wrapper{
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
  }
}

.lc-text-msg-side {
  color: white;
  background: $primary;
  text-align: right;
  max-width: 500px;
  border-radius: 20px 20px 0px 20px;
}

.lc-text-msg-not-send {
  color: rgb(196, 196, 196);
  background: white;
  display: flex;
  align-items: center;
}

.lc-text-retry {
  padding: 4px;
  margin-right: 6px;
  cursor: pointer;
}
</style>
